import ReactModal from "react-modal";
import Avatar from "react-avatar-edit";
import React from 'react'
import useIsMobile from "Hooks/useIsMobile";

function UploadModal({uploadNew, onCrop, onSubmit, onClose}) {
   const isMobile = useIsMobile();
  return (
    <ReactModal
    shouldCloseOnEsc = {true}
    shouldCloseOnOverlayClick = {true}
    onRequestClose={onClose}
    isOpen = {uploadNew}
    style={{
        overlay: {
          zIndex: 30
          
        },
        content: {
            height: isMobile ? '430px' : '530px',
            width: isMobile ? '320px' : '480px',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        }
      }}
    >    
        <div className='flex items-center flex-col mt-8 cursor-pointer'>
        <div className='flex'>
          <Avatar
            width={isMobile ? 320 : 400}
            height={isMobile ? 320 : 400}
            onCrop={onCrop}
            onClose={onClose}
            src={""}
            labelStyle= {{fontSize:15}}
            label = "Upload image"
            cropRadius={100}
            minCropRadius={100}
          />
        </div>
        <div className='flex'>
          <div 
          className="shadow-xl text-sm  w-14 h-8 mr-2 bg-sky-500 hover:bg-sky-600 text-white rounded mt-5 flex justify-center items-center cursor-pointer"
          onClick={onSubmit}>Save</div>
          <div 
          className=" shadow-xl text-sm w-14 h-8 bg-gray-300 hover:bg-gray-600 text-white rounded mt-5 flex justify-center items-center cursor-pointer"
          onClick={onClose}>Cancel</div>
        </div>
    </div>
    </ReactModal>
  )
}

export default UploadModal